import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  async err => {
    if (err.response?.status === 401) {
      const refresh = localStorage.getItem('refresh_token');
      if (refresh) {
        try {
          const { data } = await axios.post('/api/auth/refresh/', { refresh });
          localStorage.setItem('access_token', data.access);
          err.config.headers.Authorization = `Bearer ${data.access}`;
          return api(err.config);
        } catch {
          localStorage.clear();
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(err);
  }
);

export const authApi = {
  login: d => api.post('/auth/login/', d),
  register: d => api.post('/auth/register/', d),
  profile: () => api.get('/auth/profile/'),
  updateProfile: d => api.patch('/auth/profile/', d, { headers: { 'Content-Type': 'multipart/form-data' } }),
  userDetail: username => api.get(`/auth/users/${username}/`),
  followToggle: username => api.post(`/auth/users/${username}/follow/`),
  followers: username => api.get(`/auth/users/${username}/followers/`),
  following: username => api.get(`/auth/users/${username}/following/`),
};

export const storiesApi = {
  list: params => api.get('/stories/', { params }),
  myStories: () => api.get('/stories/', { params: { mine: 'true' } }),
  detail: slug => api.get(`/stories/${slug}/`),
  create: d => api.post('/stories/', d, { headers: { 'Content-Type': 'multipart/form-data' } }),
  update: (slug, d) => api.patch(`/stories/${slug}/`, d, { headers: { 'Content-Type': 'multipart/form-data' } }),
  delete: slug => api.delete(`/stories/${slug}/`),
  comment: (slug, d) => api.post(`/stories/${slug}/comment/`, d),
  like: slug => api.post(`/stories/${slug}/like/`),
  bookmark: slug => api.post(`/stories/${slug}/bookmark/`),
  uploadImage: file => {
    const fd = new FormData();
    fd.append('image', file);
    return api.post('/stories/upload-image/', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  bookmarked: () => api.get('/stories/bookmarked/'),
  categories: () => api.get('/stories/categories/'),
  tags: () => api.get('/stories/tags/'),
};

export const playersApi = {
  list: params => api.get('/players/', { params }),
  detail: id => api.get(`/players/${id}/`),
  create: d => api.post('/players/', d, { headers: { 'Content-Type': 'multipart/form-data' } }),
  update: (id, d) => api.patch(`/players/${id}/`, d, { headers: { 'Content-Type': 'multipart/form-data' } }),
};

export default api;
